import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-error-popup',
  templateUrl: './error-popup.component.html',
  styleUrls: ['./error-popup.component.css']
})
export class ErrorPopupComponent implements OnInit {
  @ViewChild('contentError') modal: ElementRef;
  modalRef: NgbModalRef;
  constructor(
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
  }
  showModal() {
    this.modalRef = this.modalService.open(this.modal, { windowClass: 'error-modal' })
    this.modalRef.result.then((data) => {
     
    }, (reason) => {

    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modal-popup/error-popup/error-popup.component.ts